/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_syl_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Count syllables in any text`)
};

const es_syl_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuenta sílabas en cualquier texto`)
};

const de_syl_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zähle Silben in jedem Text`)
};

const nl_syl_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tel lettergrepen in elke tekst`)
};

const fr_syl_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comptez les syllabes de n'importe quel texte`)
};

const it_syl_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conta le sillabe in qualsiasi testo`)
};

const pt_br2_syl_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conte sílabas em qualquer texto`)
};

const pt_syl_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conte sílabas em qualquer texto`)
};

const ja_syl_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あらゆるテキストの音節数をカウント`)
};

const zh_syl_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`统计任意文本的音节数`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const syl_nav_main_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.syl_nav_main_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("syl_nav_main_desc", locale)
	if (locale === "en") return en_syl_nav_main_desc(inputs)
	if (locale === "es") return es_syl_nav_main_desc(inputs)
	if (locale === "de") return de_syl_nav_main_desc(inputs)
	if (locale === "nl") return nl_syl_nav_main_desc(inputs)
	if (locale === "fr") return fr_syl_nav_main_desc(inputs)
	if (locale === "it") return it_syl_nav_main_desc(inputs)
	if (locale === "pt-BR") return pt_br2_syl_nav_main_desc(inputs)
	if (locale === "pt") return pt_syl_nav_main_desc(inputs)
	if (locale === "ja") return ja_syl_nav_main_desc(inputs)
	return zh_syl_nav_main_desc(inputs)
};